//#region Multi dropdown menu
$(document)
    .on('click', 'div.dropdown-menu [data-toggle="kdr-mddm"]', function (event) {
        event.preventDefault();
        event.stopPropagation();

        // chowanie wczesniej odpalonych list 
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }

        // zamykanie siostrzanych dropdown list 
        $(this).siblings().toggleClass("show");

        // auto zwijanie ddl do poczatku po jej zamknieciu 
        $(this).parents('div.dropdown.show').on('hidden.bs.dropdown', function () {
            $('.dropdown-submenu .show').removeClass("show")
        });

        $(this).siblings('div.dropdown-menu').trigger('classChangedTrigger')
    })
    .on('classChangedTrigger', 'div.dropdown-menu', function () {
        var bounding = this.getBoundingClientRect();

        if (bounding.right > $(window).width()) {
            $(this).addClass('dropdown-submenu-left')

            var reBounding = this.getBoundingClientRect();
            if (reBounding.right > $(window).width()) {
                $(this).attr('style', 'left: -200% !important')
            }
        }

    })
    .on('show.bs.dropdown', '#TopMenu .kdr-control-mddm-btn .dropdown', function () {
        $(this).find('.dropdown-menu').trigger('classChangedTrigger')
    })
    //.on('shown.bs.dropdown', '#TopMenu .kdr-control-mddm-btn .dropdown', function () {
    //    $(this).find('.dropdown-menu').trigger('classChangedTrigger')
    //})

$(document).on('show.bs.dropdown', '.kdr-control-mddm-btn', function (e) {
    let $dropdownMenu = $($(e.relatedTarget).data('bs.dropdown')._menu)

    kdrDropdown.updatePosition($dropdownMenu)
})
//#endregion